import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    padding-top: 6vw;
    /** mobile */
    @media only screen and (max-width: 900px) {
        flex-direction: column;
        margin: 40px;
        > div {
            width: 100%;
        }
        .desktop-only {
            display: none;
        }
    }
    &.mobileVersion {
        flex-direction: column;
        margin: 40px;
        > div {
            width: 100%;
        }
        .desktop-only {
            display: none;
        }
    }
    /** Desktop */
    @media only screen and (min-width: 901px) {
        &:not(.mobileVersion) {
            margin: 2.15vw;
            > div {
                width: 49.5%;
            }
            > div:first-child {
                width: 37.5%;
            }
            .mobile-only {
                display: none;
            }
        }
    }
`;

export const SubtitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    > div {
        width: 47%;
    }
    > div:first-child {
        width: 37.5%;
    }
`;

export const Section = styled.div`

`;

export const Title = styled.div`
    font-family: LSCCondensed;
    font-size: 8vw;
    @media only screen and (max-width: 900px) {
        font-size: 18vw;
    }
    &.mobileVersion {
        font-size: 18vw;
    }
    line-height: 1em;
    margin-bottom: 60px;
`;

export const Subtitle = styled.h3`
    font-family: LSCCondensed;
    font-style: italic;
    font-size: 4.7vw;
    line-height: 1em;
    margin-bottom: 60px;
`;

export const ImageContainer = styled.div`
    img {
        width: 100%;
    }
`;

export const Text = styled.p`
    font-family: futura-pt;
    font-size: 1.4vw;
    line-height: 1.5em;
    @media only screen and (max-width: 900px) {
        font-size: 22px;
    }
    @media only screen and (min-width: 901px) {
        &.mobileVersion {
            font-size: 3vw;
        }
    }
    a {
        text-decoration: none;
        color: inherit;
    }
`;